import fire from "../config/Fire";
import firebase from "firebase";

import {
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGOUT,
} from "./types";

// Load User
export const loadUser = () => async (dispatch) => {
  fire.auth().onAuthStateChanged(async (user) => {
    if (user) {
      let purchases = await fire
        .firestore()
        .collection("users")
        .doc(user.uid)
        .collection("purchases")
        .get();
      let purchasesArray = [];
      await purchases.docs.forEach((doc) => {
        const item = doc.data().item;
        // const status = doc.data().status;
        purchasesArray.push(item);
      });

      const getStripeId = await fire
        .firestore()
        .collection("users")
        .doc(user.uid)
        .get();

      const stripeCustomerId = getStripeId.data().stripe_customer_id;

      dispatch({
        type: USER_LOADED,
        payload: [user, purchasesArray, stripeCustomerId],
      });
    } else {
      dispatch({
        type: AUTH_ERROR,
      });
    }
  });
};

// Register User
export const registerWithEmailAndPassword = (
  displayName,
  email,
  password
) => async (dispatch) => {};

// Login User with Email And Password
export const loginUserWithEmailAndPassword = (email, password) => async (
  dispatch
) => {
  fire
    .auth()
    .signInWithEmailAndPassword(email, password)
    .then((user) => {
      dispatch({ type: LOGIN_SUCCESS, payload: user });
    })
    .catch((error) => {
      dispatch({
        type: LOGIN_FAIL,
        payload: error.code,
      });
    });
};

// Login User with Google
export const loginWithGoogle = () => async (dispatch) => {
  try {
    var provider = new firebase.auth.GoogleAuthProvider();
    fire
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        // This gives you a Google Access Token. You can use it to access the Google API.
        // var token = result.credential.accessToken;
        // The signed-in user info.
        var user = result.user;
        // ...
        dispatch({
          type: LOGIN_SUCCESS,
          payload: user,
        });
        dispatch(loadUser());
      })
      .catch(function (error) {
        // Handle Errors here.
        // var errorCode = error.code;
        // var errorMessage = error.message;
        // The email of the user's account used.
        // var email = error.email;
        // The firebase.auth.AuthCredential type that was used.
        // var credential = error.credential;
        // ...
      });
  } catch (err) {
    console.log(err);
    dispatch({
      type: LOGIN_FAIL,
    });
  }
};

export const logout = () => (dispatch) => {
  fire
    .auth()
    .signOut()
    .then(function () {
      // Sign-out successful.
      dispatch({ type: LOGOUT });
    })
    .catch(function (error) {
      // An error happened.
      console.log(error);
    });
};
